import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { UtmifyScript } from './components/UtmifyScript';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { WhatsInside } from './components/WhatsInside';
import { InsideLook } from './components/InsideLook';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { PurchaseToast } from './components/PurchaseToast';
export function App() {
  return <div className="w-full bg-cream text-navy" data-id="element-0" data-mp="28sbb5328r364">
      <MetaPixel data-id="element-1" data-mp="23w4fc33k781w" />
      <UtmifyScript data-id="element-2" data-mp="23ujkecdc1n3i" />
      <CountdownBar data-id="element-3" data-mp="23v2sz2h3ez4v" />
      <main data-id="element-4" data-mp="23ti67z10skhk">
        <Hero data-id="element-5" data-mp="3ik7g4ghnibqn" />
        <StatsBar data-id="element-6" data-mp="3ikh5q2ysagvt" />
        <Difference data-id="element-7" data-mp="3ij652c0mxp8x" />
        <WhatsInside data-id="element-8" data-mp="3ijpc2xoqyt86" />
        <InsideLook data-id="element-9" data-mp="3ii4qhxkeukmg" />
        <Bonuses data-id="element-10" data-mp="3ml14tc2x3ukl" />
        <Offer data-id="element-11" data-mp="3mkhlps1j704z" />
        <Guarantee data-id="element-12" data-mp="3mk83iqmq9x9u" />
        <Testimonials data-id="element-13" data-mp="3mjg9vlcoy9m7" />
        <Faq data-id="element-14" data-mp="3rc9dg5wfbbwp" />
        <FinalCta data-id="element-15" data-mp="3rbr9so7flver" />
      </main>
      <Footer data-id="element-16" data-mp="3rdkgg3i1ofmr" />
      <PurchaseToast data-id="element-17" data-mp="3rd1azm9kzjpm" />
    </div>;
}